import { ResourceAdditionalDetailsMap } from "@/store/resource-details/utils/types/resourceAdditionalDetails";
import { colDefsWithCustomComponents } from "@/components/pages/common/resource-details/components/content/general-content/components/details/ResourceDetailsGeneralContentDetails";

export const resourceDetailsGeneralContentDetailsFromMappingGenerator = (
  details: Partial<ResourceAdditionalDetailsMap>[],
) => {
  return details.map(({ title, value }) => {
    if (typeof value === "string") {
      return {
        title: title ?? "",
        value,
      };
    }

    const { customComponentIdentifier, customComponentProps } = value ?? {};

    const Component = customComponentIdentifier
      ? colDefsWithCustomComponents[customComponentIdentifier]
      : undefined;

    if (!Component || !customComponentIdentifier) {
      return {
        title: title ?? "",
        value: "",
      };
    }

    return {
      title: title ?? "",
      value: <Component {...customComponentProps} />,
    };
  });
};
